import { Button, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface Props {
  count: number;
  loading: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

export function GoldPriceStaleBanner({ count, loading, onConfirm, onDismiss }: Props) {
  return (
    <div
      style={{
        background: '#fff6f8',
        borderLeft: '3px solid #a4193d',
        padding: '8px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexShrink: 0,
      }}
    >
      <WarningOutlined style={{ color: '#a4193d', fontSize: 16 }} />
      <Text style={{ flex: 1, fontSize: 13, color: '#333' }}>
        <strong>Giá vàng đã thay đổi</strong> — {count} sản phẩm bị ảnh hưởng
      </Text>
      <Button
        type="primary"
        size="small"
        loading={loading}
        disabled={loading}
        onClick={onConfirm}
      >
        Cập nhật giá
      </Button>
      <Button size="small" onClick={onDismiss} disabled={loading}>
        Bỏ qua
      </Button>
    </div>
  );
}
